import { SOLD_PDP_YMAL_ITEMS_PER_ROW } from '../PdpRespSimilarItems/pdpRespSimilarItemsConstants.ts';

/**
 * Sold PDP grid takes SLs first (no carousel reservation). Eligible when the
 * pool has at least one full grid SL row.
 */
export function isEligibleForSoldPdpSponsoredYmalGrid({
    eligibleItemIdsCount,
    inflatedItemsCount,
    itemsPerRow = SOLD_PDP_YMAL_ITEMS_PER_ROW,
}: {
    eligibleItemIdsCount: number;
    inflatedItemsCount: number;
    itemsPerRow?: number;
}): boolean {
    return Math.max(eligibleItemIdsCount, inflatedItemsCount) >= itemsPerRow;
}
